module.exports = __webpack_public_path__ + "img/user.requesting.service.73bc2e46.jpg";